/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type MCPAllowedTools2 = {
  readOnly?: boolean | undefined;
  toolNames?: Array<string> | undefined;
};

export type MCPAllowedTools = Array<string> | MCPAllowedTools2;

/** @internal */
export const MCPAllowedTools2$inboundSchema: z.ZodType<
  MCPAllowedTools2,
  z.ZodTypeDef,
  unknown
> = z.object({
  read_only: z.boolean().optional(),
  tool_names: z.array(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    "read_only": "readOnly",
    "tool_names": "toolNames",
  });
});
/** @internal */
export type MCPAllowedTools2$Outbound = {
  read_only?: boolean | undefined;
  tool_names?: Array<string> | undefined;
};

/** @internal */
export const MCPAllowedTools2$outboundSchema: z.ZodType<
  MCPAllowedTools2$Outbound,
  z.ZodTypeDef,
  MCPAllowedTools2
> = z.object({
  readOnly: z.boolean().optional(),
  toolNames: z.array(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    readOnly: "read_only",
    toolNames: "tool_names",
  });
});

export function mcpAllowedTools2ToJSON(
  mcpAllowedTools2: MCPAllowedTools2,
): string {
  return JSON.stringify(
    MCPAllowedTools2$outboundSchema.parse(mcpAllowedTools2),
  );
}
export function mcpAllowedTools2FromJSON(
  jsonString: string,
): SafeParseResult<MCPAllowedTools2, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MCPAllowedTools2$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MCPAllowedTools2' from JSON`,
  );
}

/** @internal */
export const MCPAllowedTools$inboundSchema: z.ZodType<
  MCPAllowedTools,
  z.ZodTypeDef,
  unknown
> = z.union([
  z.array(z.string()),
  z.lazy(() => MCPAllowedTools2$inboundSchema),
]);
/** @internal */
export type MCPAllowedTools$Outbound =
  | Array<string>
  | MCPAllowedTools2$Outbound;

/** @internal */
export const MCPAllowedTools$outboundSchema: z.ZodType<
  MCPAllowedTools$Outbound,
  z.ZodTypeDef,
  MCPAllowedTools
> = z.union([
  z.array(z.string()),
  z.lazy(() => MCPAllowedTools2$outboundSchema),
]);

export function mcpAllowedToolsToJSON(
  mcpAllowedTools: MCPAllowedTools,
): string {
  return JSON.stringify(MCPAllowedTools$outboundSchema.parse(mcpAllowedTools));
}
export function mcpAllowedToolsFromJSON(
  jsonString: string,
): SafeParseResult<MCPAllowedTools, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MCPAllowedTools$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MCPAllowedTools' from JSON`,
  );
}
